import { FC } from 'react';

import { CardSkeleton } from '@/components/skeletons/CardSkeleton/CardSkeleton';
import { MAX_VISIBLE_VACANCIES } from '@/constants/common';

type Props = {
  isMine?: boolean;
  length?: number;
};

export const AdsSkeleton: FC<Props> = ({ isMine, length }) => {
  return Array.from({ length: length ?? MAX_VISIBLE_VACANCIES }).map(
    (_, index) => <CardSkeleton key={index} isMine={isMine} />
  );
};
